import _ from 'lodash';
import { apiFetch } from '../utility';

const apiBase = 'dataDump';

export const getCurrent = (p) => {
	const { callback = _.noop } = p;

	return dispatch => {
		const params = {};

		apiFetch({
			method: `${apiBase}.getCurrent`,
			params,
			dispatch,
			callback : (err, r) => {
				if (err) { return callback(err); }
				callback(null, r);
			}
		});
	};
};
